import { PAGES_URL } from 'constants/index';

export const breadcrumbCategories = [
  { label: 'Home', link: PAGES_URL.home },
  { label: 'Coleções', link: PAGES_URL.categories },
];
